<div
  class="card-tab-form content"
  [formGroup]="form">
  <app-input-person-autocomplete
    *ngIf="form?.controls?.fornitore"
    formControlName="fornitore">
  </app-input-person-autocomplete>
  <mat-form-field *ngIf="form?.controls?.tiratura">
    <input
      matInput
      formControlName="tiratura"
      [placeholder]="'Tiratura' | translate">
  </mat-form-field>
  <mat-form-field *ngIf="form?.controls?.patina">
    <input
      matInput
      formControlName="patina"
      [placeholder]="'Patina' | translate">
  </mat-form-field>
  <mat-form-field *ngIf="form?.controls?.note">
    <textarea
      matInput
      formControlName="note"
      rows="5"
      [placeholder]="'Note' | translate"></textarea>
  </mat-form-field>

  <h3>{{ 'Progetti' | translate }}</h3>
  <p *ngIf="(form?.controls?.progetti.value || []).length === 0">{{ 'Non sono presenti progetti.' }}</p>
  <app-project-form
    [form]="form?.controls?.progetti"
    [classNames]="classNames">
  </app-project-form>

  <ng-container
    formGroupName="prodotto"
    *ngIf="form?.controls?.prodotto">
    <h3>{{ 'Prodotto' | translate }}</h3>
    <mat-form-field>
      <mat-label>Valore assicurativo</mat-label>
      <mat-icon matPrefix>euro</mat-icon>
      <input
        matInput
        type="text"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="prezzoDiListino"
        [placeholder]="'Valore assicurativo' | translate">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Prezzo Pub.Imp.</mat-label>
      <mat-icon matPrefix>euro</mat-icon>
      <input
        matInput
        type="text"
        decimalMarker=","
        thousandSeparator="."
        mask="separator.2"
        formControlName="prezzoDiVendita"
        [placeholder]="'Prezzo Pub.Imp.' | translate">
    </mat-form-field>
    <mat-form-field>
      <mat-label>IVA</mat-label>
      <input
        matInput
        type="number"
        formControlName="iva"
        [placeholder]="'IVA' | translate">
    </mat-form-field>
  </ng-container>
  <mat-checkbox
    [formControl]="isOperaMadreEnableControl"
    *ngIf="form?.controls?.operaMadre && !form?.controls?.benePadre?.value">
    {{ 'Opera madre' | translate }}
  </mat-checkbox>

  <ng-container
    *ngIf="isOperaMadreEnableControl.value && form?.controls?.operaMadre && !form?.controls?.benePadre?.value"
    formGroupName="operaMadre">
    <h3>{{ 'Opera madre' | translate }}</h3>
    <mat-form-field>
      <input
        matInput
        formControlName="tiratura"
        type="number"
        [placeholder]="'Tiratura' | translate">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        formControlName="tiraturaEA"
        [placeholder]="'Tiratura EA' | translate">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        formControlName="tiraturaHC"
        type="number"
        [placeholder]="'Tiratura HC' | translate">
    </mat-form-field>
    <div class="totals-container">
      <mat-card class="total-container">
        <span class="label">Opere prodotte</span>
        <span class="value">{{ productExamples$ | async }}</span>
      </mat-card>
      <mat-card
        class="total-container"
        [class.error]="productExamplesToProduct < 0"
        *ngIf="getProductExamplesToProduct(productExamples$ | async) as productExamplesToProduct">
        <span class="label">Opere da produrre</span>
        <span class="value">{{ productExamplesToProduct }}</span>
      </mat-card>
    </div>
    <div class="totals-container">
      <mat-card class="total-container">
        <span class="label">Opere numerate</span>
        <span class="value">{{ childNumberCount$ | async }}</span>
      </mat-card>

      <mat-card class="total-container">
        <span class="label">Opere prova d'artista</span>
        <span class="value">{{ childProvaCount$ | async }}</span>
      </mat-card>

      <mat-card class="total-container">
        <span class="label">Opere fuori commercio</span>
        <span class="value">{{ childFuoriCommercioCount$ | async }}</span>
      </mat-card>
    </div>
  </ng-container>

  <ng-container *ngIf="form?.controls?.benePadre?.value">
    <h3>{{ 'Opera madre' | translate }}</h3>
    <p>
      <a [routerLink]="['/cards/oa/manager', form?.controls?.benePadre?.value]">
        {{ 'Vai alla visualizzazione dell\'opera madre' | translate }}
      </a>
    </p>
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-button
      mat-raised-button
      type="button"
      class="unlink-btn-card"
      [matTooltip]="'Per scollegare una scheda madre è necessario salvare una volta cliccato sul bottone: \'Scollega\'' | translate"
      [title]="'Per scollegare una scheda madre è necessario salvare una volta cliccato sul bottone: \'Scollega\'' | translate"
      (click)="unlinkParentCardHandler()">
      {{ 'Scollega scheda madre' | translate }}
    </button>
  </ng-container>
  <mat-divider></mat-divider>
  <div class="basi-panel" *ngIf="form?.controls?.basi">
    <h3>{{ 'Basi' | translate }}</h3>
    <div class="base-list-container">
      @for (base of basi; track base.id) {
        <div class="base-container">
          <mat-card>
            <mat-card-header>
              <mat-card-title>{{ base.titolo }}</mat-card-title>
            </mat-card-header>

            <mat-card-content>
              <p>dimensioni: {{ base.altezza }}H {{ base.larghezza }}L {{ base.profondita }}P</p>
              <p>materiale: {{ base.materiale.join(', ') }}</p>
              <p>peso: {{ base.peso }} kg</p>
              <p>Note: {{ base.note }}</p>
              <mat-slide-toggle (change)="handleBaseTipoChange($event,base)" [checked]="base.tipo===EBaseType.primary">
                primaria
              </mat-slide-toggle>
              <img *ngIf="base.thumbUrl" class="base-thumb" loading="lazy" [src]="base.thumbUrl" [alt]="base.titolo" (click)="showBaseImage(base)">
            </mat-card-content>
            <mat-card-actions>
              <div class="card-buttons">
                <button mat-mini-fab
                        matTooltip="'Per rimuovere una base è necessario salvare una volta cliccato sul bottone: \'Rimuovi\'' | translate"
                        color="warn"
                        (click)="handleRemoveBase($event,base)">
                  <mat-icon>delete</mat-icon>
                </button>
                <button mat-mini-fab matTooltip="Modifica base" color="accent"
                        [routerLink]="['/base/manager', base.id]">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
            </mat-card-actions>
          </mat-card>

        </div>
      }
    </div>


    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-button
      mat-raised-button
      type="button"
      (click)="showAddBaseDialogHandler()">
      Aggiungi base
    </button>


    <!--    <ng-container *roleVisibility="['create', 'update']; classNames: classNames">-->
    <!--      <button-->
    <!--        mat-button-->
    <!--        mat-raised-button-->
    <!--        type="button"-->
    <!--        *ngIf="base"-->
    <!--        [matTooltip]="'Per rimuovere una base è necessario salvare una volta cliccato sul bottone: \'Rimuovi\'' | translate"-->
    <!--        (click)="removeBaseHandler()">-->
    <!--        {{ 'Rimuovi base' | translate }}-->
    <!--      </button>-->
    <!--    </ng-container>-->
  </div>
  <mat-divider></mat-divider>
  <h3>{{ 'Collegamenti Web' | translate }}</h3>
  <p *ngIf="(form?.controls?.collegamentiWeb.value || []).length === 0">{{ 'Non sono presenti collegamenti.' }}</p>
  <app-link-web-form [form]="form?.controls?.collegamentiWeb"></app-link-web-form>
</div>
